"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YourDeliveryOptionsHeader = exports.ToggleWrapper = exports.Separator = exports.PriceRangeWrapper = exports.NewDeliveryRoot = exports.IconWrapper = exports.HistoryToggle = exports.FreeLabel = exports.EditDeliveryOption = exports.DeliveryOptionLabel = exports.DeliveryOptionContent = exports.ContentRoot = exports.AddressFormWrapper = exports.AddressFormTitle = exports.AddIcon = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const NewDeliveryRoot = exports.NewDeliveryRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(14)
    };
});
const EditDeliveryOption = exports.EditDeliveryOption = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        border: "1px solid ".concat(theme.palette.grey[200]),
        borderRadius: theme.spacing(2),
        cursor: 'pointer',
        display: 'flex',
        margin: theme.spacing(3, 0),
        padding: theme.spacing(4, 3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4)
        }
    };
});
const IconWrapper = exports.IconWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        backgroundColor: theme.palette.grey[100],
        borderRadius: '50%',
        display: 'flex',
        height: 45,
        justifyContent: 'center',
        width: 45,
        minHeight: 45,
        minWidth: 45
    };
});
const DeliveryOptionContent = exports.DeliveryOptionContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        margin: theme.spacing(0, 4, 0, 2)
    };
});
const DeliveryOptionLabel = exports.DeliveryOptionLabel = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        fontWeight: theme.typography.fontWeightBold
    };
});
const AddIcon = exports.AddIcon = (0, _mui.styled)(_icons.Add)({
    marginLeft: 'auto'
});
const FreeLabel = exports.FreeLabel = (0, _mui.styled)('span')((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.offer.main,
        fontWeight: theme.typography.fontWeightBold
    };
});
const PriceRangeWrapper = exports.PriceRangeWrapper = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { ownerState: { isBoldText }, theme } = param;
    return {
        color: theme.palette.text.secondary,
        fontWeight: isBoldText ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular
    };
});
const Separator = exports.Separator = (0, _mui.styled)('span')((param)=>{
    let { theme } = param;
    return {
        '&:after': {
            content: '"–"',
            margin: theme.spacing(0, 1)
        }
    };
});
const AddressFormWrapper = exports.AddressFormWrapper = (0, _mui.styled)(_components.Dialog)((param)=>{
    let { theme } = param;
    return {
        ["& .".concat(_components.dialogClasses.dialogGrid)]: {
            width: '100%',
            paddingTop: theme.spacing(1)
        },
        ["& .".concat(_components.dialogClasses.content)]: {
            paddingTop: theme.spacing(1)
        },
        '& .MuiAutocomplete-root .MuiInputBase-root .MuiInputBase-input': {
            boxSizing: 'content-box'
        },
        '& .MuiTextField-root .MuiInputBase-root .MuiInputBase-input': {
            boxSizing: 'content-box'
        }
    };
});
const AddressFormTitle = exports.AddressFormTitle = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(6)
        }
    };
});
const ToggleWrapper = exports.ToggleWrapper = (0, _mui.styled)('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const ContentRoot = exports.ContentRoot = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(4)
        }
    };
});
const HistoryToggle = exports.HistoryToggle = (0, _mui.styled)(_components.Toggle)((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        zIndex: 0,
        [theme.breakpoints.up('sm')]: {
            maxWidth: 450
        }
    };
});
const YourDeliveryOptionsHeader = exports.YourDeliveryOptionsHeader = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'end',
        padding: theme.spacing(2, 0)
    };
});
